<template>
    <!--Blog start-->
  <section class="theme-bg-gray " id="development">
    <CoolLightBox 
      :items="items" 
      :index="index"
      @close="index = null">
    </CoolLightBox>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-left">
          <div class="section-title">
            <h2 class="text-green">กยท. ก้าวไกลเพื่อสังคม</h2>
            <h2 class="text-green">RAOT FOR LIFE</h2>
              
            <img :src='"../assets/images/green-line.png"' alt="/title-line">
          </div>
        </div>
       
       
      </div>

       <div class="row faq-row text-center">
         <div class="col-lg-3">
         </div>
        <div class="col-lg-6">
           <img @click="index = 1" src="../assets/images/innovation-1.jpg" alt="news-1" class="img-fluid">
        </div>
        <div class="col-lg-3">
         </div>
      </div>
    </div>
  </section>
    <!--Blog end -->
</template>
<script>
import CoolLightBox from 'vue-cool-lightbox'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
export default {
  name: 'Blog',
   components: {
       CoolLightBox,
  },
  data() {
    return {
     items: [
        'https://youngcyber.xyz/inovation/innovation-2.jpg',
        'https://youngcyber.xyz/inovation/innovation-3.jpg',
        'https://youngcyber.xyz/inovation/innovation-4.jpg',
        'https://youngcyber.xyz/inovation/innovation-5.jpg',
        'https://youngcyber.xyz/inovation/innovation-6.jpg',
        'https://youngcyber.xyz/inovation/innovation-7.jpg',
        'https://youngcyber.xyz/inovation/innovation-8.jpg',
        'https://youngcyber.xyz/inovation/innovation-9.jpg',
        'https://youngcyber.xyz/inovation/innovation-10.jpg',
        'https://youngcyber.xyz/inovation/innovation-11.jpg',
        'https://youngcyber.xyz/inovation/innovation-12.jpg',
        'https://youngcyber.xyz/inovation/innovation-13.jpg',
        'https://youngcyber.xyz/inovation/innovation-14.jpg',
        'https://youngcyber.xyz/inovation/innovation-15.jpg',
        'https://youngcyber.xyz/inovation/innovation-16.jpg',
        'https://youngcyber.xyz/inovation/innovation-17.jpg',
        'https://youngcyber.xyz/inovation/innovation-18.jpg',
        
      ],
      index: null
    }
  },

  
}
</script>
